// import React, { Component } from 'react'
// import { Card, CardBody, CardHeader } from 'reactstrap';
// import ReactToPrint from "react-to-print";
// import Axios from "axios";
// import ReportHeader_Swiss from './common/ReportHeader_Swiss';
// import ReportFooter_Swiss from './common/ReportFooter_Swiss';
// import "./ReportFullGeneralDamageImage.css"
// import ScrollToTop from './common/ScrollToTop';

// class ReportFullGeneralDamageImage extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             lang: "",
//             words: {},
//         }
//     }
//     getLang = () => {
//         const base_url = window.location.origin;
//         Axios.get(`${base_url}/lang.json`).then((res) => {
//             let lang = localStorage.getItem("lang");
//             this.setState({ lang: lang });
//             this.setState({ words: res.data });
//         });
//     };
//     lang = (word) => {
//         const { lang, words } = this.state;
//         return words[word] ? words[word][lang] : word;
//     };
//     async componentDidMount() {
//         this.getLang();
//     }

//     render() {
//         return (
//             <>
//                 <div className="animated fadeIn">
//                     <div xs="12" sm="12" className="p-2">
//                         <Card className="print_button_card">
//                             <CardHeader>
//                                 <div className="container-fluid">
//                                     <div className="row align-items-center p-0">
//                                         <div className="col-lg-3 col-md-4 col-sm-12 col-12 mt-sm-10">
//                                             <small> <span>{this.lang("VIN Number")} :</span> {localStorage.getItem("selectedFile")}</small>
//                                         </div>
//                                         <div className="col-lg-9 col-md-8 col-sm-12 col-12 mt-sm-10 p-0">
//                                             <div className="d-flex align-items-center justify-content-end flex-wrap btn-position">
//                                                 <ReactToPrint
//                                                     trigger={() => {
//                                                         document.title = localStorage.getItem("selectedFile");
//                                                         return (
//                                                             <button className="btn btn-danger btn-lg pull-right">
//                                                                 <i className="fa fa-print" /> {this.lang("Print PDF")}
//                                                             </button>
//                                                         );
//                                                     }}
//                                                     content={() => this.componentRef}
//                                                 />
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </CardHeader>
//                         </Card>
//                         <div
//                             className="container p-0"
//                             ref={(el) => (this.componentRef = el)}
//                         >
//                             {/* Diagonal Images */}
//                             <div className="row general-report-page-break p-0">
//                                 <div className="col-sm-12 full-height-col p-0">
//                                     <Card>
//                                         <div id="main_footer">
//                                             <ReportHeader_Swiss />
//                                         </div>
//                                         <CardBody className="col-zero">
//                                             <div className="general_damage_report_wrapper">
//                                                 <div className="container main_container">
//                                                     <div className="row main_row">
//                                                         <div className="col-sm-12">
//                                                             <h3 className="general-report-title">
//                                                                 Diagonal <span> {this.lang("View")} </span>{" "}
//                                                             </h3>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
//                                                             <div className='general-damage-image-row'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Dashboard.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
//                                                             <div className='general-damage-image-row'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_Trunk_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
//                                                             <div className='general-damage-image-row'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_TrunkCover_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
//                                                             <div className='general-damage-image-row'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightFrontFender_3.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 {/* </div> */}
//                                             </div>
//                                         </CardBody>
//                                         {/* <ReportFooter /> */}
//                                         <ReportFooter_Swiss />
//                                     </Card>
//                                 </div>
//                             </div>

//                             {/* Left Side Images - 1 */}
//                             <div className="row general-report-page-break p-0">
//                                 <div className="col-sm-12 full-height-col p-0">
//                                     <Card>
//                                         <div id="main_footer">
//                                             <ReportHeader_Swiss />
//                                         </div>
//                                         <CardBody className="col-zero">
//                                             <div className="general_damage_report_wrapper">
//                                                 <div className="container main_container">
//                                                     <div className="row main_row">
//                                                         <div className="col-sm-12">
//                                                             <h3 className="general-report-title">
//                                                                 {this.lang("Left")} <span> {this.lang("View")} </span>{" "}
//                                                             </h3>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftFrontFender_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Left FrontFender
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftFrontFender_2.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Left FrontFender
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftFrontDoor_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Left FrontDoor
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 {/* </div> */}
//                                             </div>
//                                         </CardBody>
//                                         {/* <ReportFooter /> */}
//                                         <ReportFooter_Swiss />
//                                     </Card>
//                                 </div>
//                             </div>

//                             {/* Left Side Images - 2 */}
//                             <div className="row general-report-page-break p-0">
//                                 <div className="col-sm-12 full-height-col p-0">
//                                     <Card>
//                                         <div id="main_footer">
//                                             <ReportHeader_Swiss />
//                                         </div>
//                                         <CardBody className="col-zero">
//                                             <div className="general_damage_report_wrapper">
//                                                 <div className="container main_container">
//                                                     <div className="row main_row">
//                                                         <div className="col-sm-12">
//                                                             <h3 className="general-report-title">
//                                                                 {this.lang("Left")} <span> {this.lang("View")} </span>{" "}
//                                                             </h3>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftFrontDoor_2.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Left FrontDoor
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftBackDoor_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Left BackDoor
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftBackDoor_2.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Left BackDoor
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 {/* </div> */}
//                                             </div>
//                                         </CardBody>
//                                         {/* <ReportFooter /> */}
//                                         <ReportFooter_Swiss />
//                                     </Card>
//                                 </div>
//                             </div>

//                             {/* Left Side Images - 3 */}
//                             <div className="row general-report-page-break p-0">
//                                 <div className="col-sm-12 full-height-col p-0">
//                                     <Card>
//                                         <div id="main_footer">
//                                             <ReportHeader_Swiss />
//                                         </div>
//                                         <CardBody className="col-zero">
//                                             <div className="general_damage_report_wrapper">
//                                                 <div className="container main_container">
//                                                     <div className="row main_row">
//                                                         <div className="col-sm-12">
//                                                             <h3 className="general-report-title">
//                                                                 {this.lang("Left")} <span> {this.lang("View")} </span>{" "}
//                                                             </h3>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftBackFender_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Left BackFender
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftBackFender_2.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Left BackFender
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 {/* </div> */}
//                                             </div>
//                                         </CardBody>
//                                         {/* <ReportFooter /> */}
//                                         <ReportFooter_Swiss />
//                                     </Card>
//                                 </div>
//                             </div>

//                             {/* Right Side Images - 1 */}
//                             <div className="row general-report-page-break p-0">
//                                 <div className="col-sm-12 full-height-col p-0">
//                                     <Card>
//                                         <div id="main_footer">
//                                             <ReportHeader_Swiss />
//                                         </div>
//                                         <CardBody className="col-zero">
//                                             <div className="general_damage_report_wrapper">
//                                                 <div className="container main_container">
//                                                     <div className="row main_row">
//                                                         <div className="col-sm-12">
//                                                             <h3 className="general-report-title">
//                                                                 {this.lang("Right")} <span> {this.lang("View")} </span>{" "}
//                                                             </h3>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightFrontFender_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Right FrontFender
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightFrontFender_2.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Right FrontFender
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightFrontDoor_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Right FrontDoor
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 {/* </div> */}
//                                             </div>
//                                         </CardBody>
//                                         {/* <ReportFooter /> */}
//                                         <ReportFooter_Swiss />
//                                     </Card>
//                                 </div>
//                             </div>

//                             {/* Right Side Images - 2 */}
//                             <div className="row general-report-page-break p-0">
//                                 <div className="col-sm-12 full-height-col p-0">
//                                     <Card>
//                                         <div id="main_footer">
//                                             <ReportHeader_Swiss />
//                                         </div>
//                                         <CardBody className="col-zero">
//                                             <div className="general_damage_report_wrapper">
//                                                 <div className="container main_container">
//                                                     <div className="row main_row">
//                                                         <div className="col-sm-12">
//                                                             <h3 className="general-report-title">
//                                                                 {this.lang("Right")} <span> {this.lang("View")} </span>{" "}
//                                                             </h3>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightFrontDoor_2.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Right FrontDoor
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightBackDoor_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Right BackDoor
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightBackDoor_2.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Right BackDoor
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 {/* </div> */}
//                                             </div>
//                                         </CardBody>
//                                         {/* <ReportFooter /> */}
//                                         <ReportFooter_Swiss />
//                                     </Card>
//                                 </div>
//                             </div>

//                             {/* Right Side Images - 3 */}
//                             <div className="row general-report-page-break p-0">
//                                 <div className="col-sm-12 full-height-col p-0">
//                                     <Card>
//                                         <div id="main_footer">
//                                             <ReportHeader_Swiss />
//                                         </div>
//                                         <CardBody className="col-zero">
//                                             <div className="general_damage_report_wrapper">
//                                                 <div className="container main_container">
//                                                     <div className="row main_row">
//                                                         <div className="col-sm-12">
//                                                             <h3 className="general-report-title">
//                                                                 {this.lang("Right")} <span> {this.lang("View")} </span>{" "}
//                                                             </h3>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightBackFender_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Right BackFender
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightBackFender_2.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Right BackFender
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 {/* </div> */}
//                                             </div>
//                                         </CardBody>
//                                         {/* <ReportFooter /> */}
//                                         <ReportFooter_Swiss />
//                                     </Card>
//                                 </div>
//                             </div>

//                             {/* Roof Side Images - 1*/}
//                             <div className="row general-report-page-break p-0">
//                                 <div className="col-sm-12 full-height-col p-0">
//                                     <Card>
//                                         <div id="main_footer">
//                                             <ReportHeader_Swiss />
//                                         </div>
//                                         <CardBody className="col-zero">
//                                             <div className="general_damage_report_wrapper">
//                                                 <div className="container main_container">
//                                                     <div className="row main_row">
//                                                         <div className="col-sm-12">
//                                                             <h3 className="general-report-title">
//                                                                 {this.lang("Roof")}
//                                                             </h3>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_Roof_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Roof
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_Roof_2.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Roof
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_Roof_3.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Roof
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 {/* </div> */}
//                                             </div>
//                                         </CardBody>
//                                         {/* <ReportFooter /> */}
//                                         <ReportFooter_Swiss />
//                                     </Card>
//                                 </div>
//                             </div>

//                             {/* Hood Side Images - 1*/}
//                             <div className="row general-report-page-break p-0">
//                                 <div className="col-sm-12 full-height-col p-0">
//                                     <Card>
//                                         <div id="main_footer">
//                                             <ReportHeader_Swiss />
//                                         </div>
//                                         <CardBody className="col-zero">
//                                             <div className="general_damage_report_wrapper">
//                                                 <div className="container main_container">
//                                                     <div className="row main_row">
//                                                         <div className="col-sm-12">
//                                                             <h3 className="general-report-title">
//                                                                 {this.lang("Hood")}
//                                                             </h3>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_Hood_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Hood
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_Hood_2.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Hood
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_Hood_3.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Hood
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 {/* </div> */}
//                                             </div>
//                                         </CardBody>
//                                         {/* <ReportFooter /> */}
//                                         <ReportFooter_Swiss />
//                                     </Card>
//                                 </div>
//                             </div>

//                             {/* Trunk Side Images - 1*/}
//                             <div className="row general-report-page-break p-0">
//                                 <div className="col-sm-12 full-height-col p-0">
//                                     <Card>
//                                         <div id="main_footer">
//                                             <ReportHeader_Swiss />
//                                         </div>
//                                         <CardBody className="col-zero">
//                                             <div className="general_damage_report_wrapper">
//                                                 <div className="container main_container">
//                                                     <div className="row main_row">
//                                                         <div className="col-sm-12">
//                                                             <h3 className="general-report-title">
//                                                                 {this.lang("Trunk")}
//                                                             </h3>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_Trunk_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Trunk
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_TrunkCover_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         TrunkCover
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </CardBody>
//                                         <ReportFooter_Swiss />
//                                     </Card>
//                                 </div>
//                             </div>

//                             {/* Tyres Side Images - 1*/}
//                             <div className="row general-report-page-break p-0">
//                                 <div className="col-sm-12 full-height-col p-0">
//                                     <Card>
//                                         <div id="main_footer">
//                                             <ReportHeader_Swiss />
//                                         </div>
//                                         <CardBody className="col-zero">
//                                             <div className="general_damage_report_wrapper">
//                                                 <div className="container main_container">
//                                                     <div className="row main_row">
//                                                         <div className="col-sm-12">
//                                                             <h3 className="general-report-title">
//                                                                 {this.lang("Tyres")}
//                                                             </h3>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftFrontTyre_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Left FrontTyre
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftBackTyre_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Left BackTyre
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightFrontTyre_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Right FrontTyre
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </CardBody>
//                                         <ReportFooter_Swiss />
//                                     </Card>
//                                 </div>
//                             </div>

//                             {/* Tyres Side Images - 1*/}
//                             <div className="row general-report-page-break p-0">
//                                 <div className="col-sm-12 full-height-col p-0">
//                                     <Card>
//                                         <div id="main_footer">
//                                             <ReportHeader_Swiss />
//                                         </div>
//                                         <CardBody className="col-zero">
//                                             <div className="general_damage_report_wrapper">
//                                                 <div className="container main_container">
//                                                     <div className="row main_row">
//                                                         <div className="col-sm-12">
//                                                             <h3 className="general-report-title">
//                                                                 {this.lang("Tyres")}
//                                                             </h3>
//                                                         </div>
//                                                     </div>
//                                                     <div className="row main_row">
//                                                         <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
//                                                             <div className='general-damage-image-row three-image'>
//                                                                 <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightBackTyre_1.jpg' alt='Part Image Name' />
//                                                             </div>
//                                                         </div>
//                                                         <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
//                                                             <div className='general-damage-data-row'>
//                                                                 <div className='damag-table-wrapper'>
//                                                                     <div className='table-responsive'>
//                                                                         <table className='table table-bordered'>
//                                                                             <thead>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Parts Name
//                                                                                     </th>
//                                                                                     <th>
//                                                                                         Right BackTyre
//                                                                                     </th>
//                                                                                 </tr>
//                                                                             </thead>
//                                                                             <tbody>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Type
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         Scratch
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Side
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         LEFT
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Width
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         25.40(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Height
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         57.1(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                                 <tr>
//                                                                                     <th>
//                                                                                         Area
//                                                                                     </th>
//                                                                                     <td>
//                                                                                         1090(cm)
//                                                                                     </td>
//                                                                                 </tr>
//                                                                             </tbody>
//                                                                         </table>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 {/* </div> */}
//                                             </div>
//                                         </CardBody>
//                                         {/* <ReportFooter /> */}
//                                         <ReportFooter_Swiss />
//                                     </Card>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <ScrollToTop />
//             </>
//         )
//     }
// }

// export default ReportFullGeneralDamageImage;
import React, { Component } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import ReactToPrint from "react-to-print";
import Axios from "axios";
import ReportHeader_Swiss from "./common/ReportHeader_Swiss";
import ReportFooter_Swiss from "./common/ReportFooter_Swiss";
import "./ReportFullGeneralDamageImage.css";
import ScrollToTop from "./common/ScrollToTop";
import { configuration } from "../appConfig";
import Swal from "sweetalert2";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toggleDamageImages } from "../redux/actions/showReportDamageImage";
import { reportAuthorized } from "../redux/actions/reportAuthorized";
import "../screens/common/DamageToggleButton.css";
import SwissFullReportAuthorization2 from "./common/SwissFullReportAuthorization2";
import { updateJsonData } from "../redux/actions/updateJsonData";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
class ReportFullGeneralDamageImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "",
      words: {},
      jsonData: {},
      tyreJsonData: [],
      showReportDamageImages: true,
      showDamageImages: 0,
      imageAvailability: {}
    };
  }
  getLang = () => {
    const base_url = window.location.origin;
    Axios.get(`${base_url}/lang.json`).then((res) => {
      let lang = localStorage.getItem("lang");
      this.setState({ lang: lang });
      this.setState({ words: res.data });
    });
  };
  lang = (word) => {
    const { lang, words } = this.state;
    return words[word] ? words[word][lang] : word;
  };
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.lang !== this.state.lang) {
      this.setState({
        lang: nextProps.lang,
      });
    } else return null;
  };
  getData = () => {
    Axios.get(configuration.getData, {
      params: {
        vin: localStorage.getItem("selectedFile"),
        partnerId: localStorage.getItem("partnerId"),
      },
    })
      .then((res) => {
        this.props.reportAuthorized({
          Authorized: res.data.Authorized,
          DATReportAuthorized: res.data.DATReportAuthorized,
          MiniReportAuthorized: res.data.MiniReportAuthorized,
          FullReportAuthorized: res.data.FullReportAuthorized,
          DetailedReportAuthorized: res.data.DetailedReportAuthorized,
          AmericanReportAuthorized: res.data.AmericanReportAuthorized,
        });
        const data = res.data && res.data.Dents.map((ele) => ele);
        this.setState({
          jsonData: res.data && res.data.Dents,
          tyreJsonData: data,
        });
        this.props.updateJsonData(res.data)
      })
      .catch((err) => console.log(err));
  };
  getFallbackDetails = () => {
    const url =
      configuration.getFallbackDetails +
      `?partner_id=${localStorage.getItem("partnerId")}`;
    Axios.get(url)
      .then((res) => {
        if (res && res.data) {
          this.setState({
            showReportDamageImages:
              res.data.is_default_damage_image == 1 ? true : false,
            showDamageImages: res.data.is_damage_image,
          });
        } else {
          Toast.fire({
            type: "error",
            title: "Something went wrong! Please try again later.",
          });
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Something went wrong! Please try again later.",
        });
      });
  };
  async componentDidMount() {
    this.getLang();
    this.getData();
    this.getFallbackDetails();
    this.checkAllImagesExist();
  }

  checkAllImagesExist = () => {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    const {showReportDamageImages} = this.state
    const toggleDamageImage = this.props.toggleReportDamageImage

    const imagePaths = {
      underbody: `${configuration.imagePath}/scanImages/${partnerId}/${selectedFile}${toggleDamageImage ? "/damages" : ""}/Report_${"Underbody"}_1.jpg`,

      // LeftFrontTyre: `${configuration.imagePath}/scanImages/${partnerId}/${selectedFile}/damages/Report_LeftFrontTyre_1.jpg`,
      // LeftBackTyre: `${configuration.imagePath}/scanImages/${partnerId}/${selectedFile}/damages/Report_LeftBackTyre_1.jpg`,
      // RightFrontTyre: `${configuration.imagePath}/scanImages/${partnerId}/${selectedFile}/damages/Report_RightFrontTyre_1.jpg`,
      // RightBackTyre: `${configuration.imagePath}/scanImages/${partnerId}/${selectedFile}/damages/Report_RightBackTyre_1.jpg`,
    };

    const checkImage = (url) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
      });
    };

    const checkAllImages = async () => {
      const results = {};

      for (const [key, url] of Object.entries(imagePaths)) {
        const isAvailable = await checkImage(url);
        results[key] = isAvailable;
      }

      this.setState({ imageAvailability: results });
    };

    checkAllImages();
  };

  // handleToggleDamageImages = (e) => {
  //   const showReportDamageImages = e.target.checked;
  //   this.setState({
  //     showReportDamageImages,
  //   });
  //   this.props.toggleDamageImages(showReportDamageImages);
  // };

  render() {
    const partnerId = localStorage.getItem("partnerId");
    const selectedFile = localStorage.getItem("selectedFile");
    const { jsonData, tyreJsonData, showReportDamageImages, showDamageImages, imageAvailability } =
      this.state;
    const toggleDamageImage = this.props.toggleReportDamageImage
    const diagonalView = [
      {
        src: `${
          configuration.imagePath
        }/scanImages/${partnerId}/${selectedFile}${
          toggleDamageImage ? "/damages" : ""
        }/Dashboard.jpg`,
        alt: "Dashboard",
      },
      {
        src: `${
          configuration.imagePath
        }/scanImages/${partnerId}/${selectedFile}${
          toggleDamageImage ? "/damages" : ""
        }/Report_Trunk_1.jpg`,
        alt: "Report Trunk",
      },
      {
        src: `${
          configuration.imagePath
        }/scanImages/${partnerId}/${selectedFile}${
          toggleDamageImage ? "/damages" : ""
        }/Report_TrunkCover_1.jpg`,
        alt: "Report TrunkCover",
      },
      {
        src: `${
          configuration.imagePath
        }/scanImages/${partnerId}/${selectedFile}${
          toggleDamageImage ? "/damages" : ""
        }/Report_RightFrontFender_3.jpg`,
        alt: "Report Right Front Fender",
      },
    ];
    const tyres = [
      {
        src: `${
          configuration.imagePath
        }/scanImages/${partnerId}/${selectedFile}${
          toggleDamageImage ? "/damages" : ""
        }/Report_LeftFrontTyre_1.jpg`,
        partName: "LeftFrontTyre",
      },
      {
        src: `${
          configuration.imagePath
        }/scanImages/${partnerId}/${selectedFile}${
          toggleDamageImage ? "/damages" : ""
        }/Report_LeftBackTyre_1.jpg`,
        partName: "LeftBackTyre",
      },
      {
        src: `${
          configuration.imagePath
        }/scanImages/${partnerId}/${selectedFile}${
          toggleDamageImage ? "/damages" : ""
        }/Report_RightBackTyre_1.jpg`,
        partName: "RightBackTyre",
      },
      {
        src: `${
          configuration.imagePath
        }/scanImages/${partnerId}/${selectedFile}${
          toggleDamageImage ? "/damages" : ""
        }/Report_RightFrontTyre_1.jpg`,
        partName: "RightFrontTyre",
      },
    ];
    return (
      <>
        <div className="animated fadeIn">
          <div xs="12" sm="12" className="p-2">
            <Card className="print_button_card">
              <CardHeader>
                <div className="container-fluid">
                  <div className="row align-items-center p-0">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12 mt-sm-10">
                      <small>
                        {" "}
                        <span>{this.lang("VIN Number")} :</span>{" "}
                        {localStorage.getItem("selectedFile")}
                      </small>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12 mt-sm-10">
                      <div className="d-flex align-items-center justify-content-end flex-wrap btn-position image_replace_toogle">
                        {/* {showDamageImages == "1" || showDamageImages == 1 ? (
                          <>
                            {configuration.getVersionUrl == "https://backend.drivenscan.live" ?
                            <>
                          <span className="main_switchbar_wrapper_images">
                            <label className="switch">
                              <input
                                className="switch-input"
                                type="checkbox"
                                name="showExtraImages"
                                value={toggleDamageImage}
                                checked={toggleDamageImage}
                                onClick={(e) =>
                                  this.handleToggleDamageImages(e)
                                }
                              />
                              <span
                                className="switch-label"
                                data-on={this.lang("Damages_1")}
                                data-off={this.lang("H")}
                              ></span>
                              <span className="switch-handle"></span>
                            </label>
                          </span>
                          </>
                          :
                         <>
                          <span>{this.lang("Damage Images")} :</span>
                          <span className="main_switchbar_wrapper_images">
                            <label className="switch">
                              <input
                                className="switch-input"
                                type="checkbox"
                                name="showExtraImages"
                                value={toggleDamageImage}
                                checked={toggleDamageImage}
                                onClick={(e) =>
                                  this.handleToggleDamageImages(e)
                                }
                              />
                              <span
                                className="switch-label"
                                data-on={this.lang("Yes")}
                                data-off={this.lang("No")}
                              ></span>
                              <span className="switch-handle"></span>
                            </label>
                          </span>
                          </> }
                          </>
                        ) : (
                          ""
                        )} */}

                        <SwissFullReportAuthorization2 />
                        
                        <ReactToPrint
                          trigger={() => {
                            document.title =
                              localStorage.getItem("selectedFile");
                            return (
                              <button className="btn btn-danger btn-lg pull-right">
                                <i className="fa fa-print" />{" "}
                                {this.lang("Print PDF")}
                              </button>
                            );
                          }}
                          content={() => this.componentRef}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </CardHeader>
            </Card>
            <div
              className="container p-0"
              ref={(el) => (this.componentRef = el)}
            >
              {/* Diagonal Images */}
              <div className="row general-report-page-break p-0">
                <div className="col-sm-12 full-height-col p-0">
                  <Card>
                    <div id="main_footer">
                      <ReportHeader_Swiss />
                    </div>
                    <CardBody className="col-zero">
                      <div className="general_damage_report_wrapper">
                        <div className="container main_container">
                          <div className="row main_row">
                            <div className="col-sm-12">
                              <h3 className="general-report-title">
                                Diagonal <span> {this.lang("View")} </span>{" "}
                              </h3>
                            </div>
                          </div>
                          <div className="row main_row">
                            {diagonalView.map((image, index) => {
                              return (
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                  <div className="general-damage-image-row forth-images">
                                    {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Dashboard.jpg' alt='Part Image Name' /> */}
                                    {
                                      <img
                                        alt={image.alt}
                                        className="partImage"
                                        src={image.src}
                                        zoom="20"
                                        onError={(img_comp) =>
                                          (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                        }
                                      />
                                    }
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        {/* </div> */}
                      </div>
                    </CardBody>
                    {/* <ReportFooter /> */}
                    <ReportFooter_Swiss />
                  </Card>
                </div>
              </div>
              {/* Under Body Image */}
              {imageAvailability.underbody &&
              <div className="row general-report-page-break p-0">
                <div className="col-sm-12 full-height-col p-0">
                  <Card>
                  <div className="general_damage_report_wrapper">
                    <div id="main_footer">
                      <ReportHeader_Swiss />
                    </div>
                    <CardBody className="p-0">
                      <div className="newFormatReport p-0 m-0">
                        {/* underbody */}
                        <div className="container text-main-heading mt-2 p-0">
                          <div className="row mt-4">
                            <div className="col-sm-12">
                              <h3>
                                {this.lang("Underbody")}
                                {/* <span> {this.lang("View")}</span>{" "} */}
                              </h3>
                            </div>
                          </div>
                          <div className="row mt-1 equal justify-content-center underbody_image">
                            <div className="col-lg-6 col-md-6 col-sm-6  d-flex">
                              <div className="row underbody-image-row-wrapper">
                                <div className="col-sm-12 p-0">
                                  <img
                                    alt=""
                                    className="partImage h-100"
                                    src={`${
                                      configuration.imagePath
                                    }/scanImages/${partnerId}/${selectedFile}${
                                      toggleDamageImage ? "/damages" : ""
                                    }/Report_${"Underbody"}_1.jpg`}
                                    zoom="20"
                                    onError={(img_comp) =>
                                      (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                    }
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                    {/* <ReportFooter /> */}
                    <ReportFooter_Swiss />
                </div>
                  </Card>
                </div>
              </div>
              }
              {/* Front Bumber */}
              <div className="row general-report-page-break p-0">
                <div className="col-sm-12 full-height-col p-0">
                  <Card>
                    <div id="main_footer">
                      <ReportHeader_Swiss />
                    </div>
                    <CardBody className="col-zero">
                      <div className="general_damage_report_wrapper">
                        <div className="container main_container">
                          <div className="row main_row">
                            <div className="col-sm-12">
                              <h3 className="general-report-title">
                                {this.lang("Front")}{" "}
                                <span> {this.lang("View")} </span>{" "}
                              </h3>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftFrontFender_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_LeftFrontBumper_4.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("LeftFrontBumper")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            <>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                              </>
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftFrontBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontBumper"
                                                  ) {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Name</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftFrontBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {
                                                            dentDamage && dentDamage.name
                                                          }
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Width</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.width
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftFrontBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage.width}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Height</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.length
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftFrontBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage.length}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Area</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.area
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftFrontBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage.area}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Repair Cost</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.repairCost
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftFrontBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftFrontDoor_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_RightFrontBumper_4.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("RightFrontBumper")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (
                                                  item.Part === "RightFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightFrontBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontBumper"
                                                  ) {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Name</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightFrontBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage && dentDamage.name
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Width</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.width
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightFrontBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.width
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Height</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.length
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightFrontBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.length
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Area</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.area
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightFrontBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.area
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Repair Cost</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.repairCost
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightFrontBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightFrontBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* </div> */}
                      </div>
                    </CardBody>
                    {/* <ReportFooter /> */}
                    <ReportFooter_Swiss />
                  </Card>
                </div>
              </div>
              {/* Left Side Images - 1 */}
              <div className="row general-report-page-break p-0">
                <div className="col-sm-12 full-height-col p-0">
                  <Card>
                    <div id="main_footer">
                      <ReportHeader_Swiss />
                    </div>
                    <CardBody className="col-zero">
                      <div className="general_damage_report_wrapper">
                        <div className="container main_container">
                          <div className="row main_row">
                            <div className="col-sm-12">
                              <h3 className="general-report-title">
                                {this.lang("Left")}{" "}
                                <span> {this.lang("View")} </span>{" "}
                              </h3>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftFrontFender_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_LeftFrontFender_1.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("LeftFrontFender")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftFrontFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontFender"
                                                  ) {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Name</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftFrontFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {
                                                            dentDamage && dentDamage.name
                                                          }
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Width</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.width
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftFrontFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage.width}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Height</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.length
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftFrontFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage.length}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Area</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.area
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftFrontFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage.area}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Repair Cost</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.repairCost
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftFrontFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftFrontFender_2.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_LeftFrontFender_2.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftFrontDoor_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_LeftFrontDoor_1.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("LeftFrontDoor")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (
                                                  item.Part === "LeftFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "LeftFrontDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontDoor"
                                                  ) {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Name</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "LeftFrontDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage && dentDamage.name
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Width</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.width
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "LeftFrontDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.width
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Height</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.length
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "LeftFrontDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.length
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Area</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.area
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "LeftFrontDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.area
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Repair Cost</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.repairCost
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "LeftFrontDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftFrontDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* </div> */}
                      </div>
                    </CardBody>
                    {/* <ReportFooter /> */}
                    <ReportFooter_Swiss />
                  </Card>
                </div>
              </div>

              {/* Left Side Images - 2 */}
              <div className="row general-report-page-break p-0">
                <div className="col-sm-12 full-height-col p-0">
                  <Card>
                    <div id="main_footer">
                      <ReportHeader_Swiss />
                    </div>
                    <CardBody className="col-zero">
                      <div className="general_damage_report_wrapper">
                        <div className="container main_container">
                          <div className="row main_row">
                            <div className="col-sm-12">
                              <h3 className="general-report-title">
                                {this.lang("Left")}{" "}
                                <span> {this.lang("View")} </span>{" "}
                              </h3>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftFrontDoor_2.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_LeftFrontDoor_2.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftBackDoor_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_LeftBackDoor_1.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("LeftBackDoor")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (
                                                  item.Part === "LeftBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "LeftBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (
                                                    item.Part === "LeftBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Name</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.relativeSize
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "LeftBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part === "LeftBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage && dentDamage.name
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Width</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.width
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "LeftBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part === "LeftBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.width
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Height</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.length
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "LeftBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part === "LeftBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.length
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Area</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.area
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "LeftBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part === "LeftBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.area
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Repair Cost</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.repairCost
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "LeftBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part === "LeftBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftBackDoor_2.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_LeftBackDoor_2.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* </div> */}
                      </div>
                    </CardBody>
                    {/* <ReportFooter /> */}
                    <ReportFooter_Swiss />
                  </Card>
                </div>
              </div>

              {/* Left Side Images - 3 */}
              <div className="row general-report-page-break p-0">
                <div className="col-sm-12 full-height-col p-0">
                  <Card>
                    <div id="main_footer">
                      <ReportHeader_Swiss />
                    </div>
                    <CardBody className="col-zero">
                      <div className="general_damage_report_wrapper">
                        <div className="container main_container">
                          <div className="row main_row">
                            <div className="col-sm-12">
                              <h3 className="general-report-title">
                                {this.lang("Left")}{" "}
                                <span> {this.lang("View")} </span>{" "}
                              </h3>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftBackFender_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_LeftBackFender_1.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("LeftBackFender")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (
                                                  item.Part === "LeftBackFender"
                                                ) {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftBackFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftBackFender"
                                                  ) {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        {/* <tr>
                                          <th>Name</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.relativeSize
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                        </tr> */}
                                        <tr>
                                          <th>Name</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftBackFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftBackFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage && dentDamage.name
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        {/* <tr>
                                          <th>Width</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.width
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                        </tr> */}
                                        <tr>
                                          <th>Width</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftBackFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftBackFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.width
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        {/* <tr>
                                          <th>Height</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.length
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                        </tr> */}
                                        <tr>
                                          <th>Height</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftBackFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftBackFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.width
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        {/* <tr>
                                          <th>Area</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.area
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                        </tr> */}
                                        <tr>
                                          <th>Area</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftBackFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftBackFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.area
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        {/* <tr>
                                          <th>Repair Cost</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.repairCost
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                        </tr> */}
                                        <tr>
                                          <th>Repair Cost</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "LeftBackFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftBackFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftBackFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftBackFender_2.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_LeftBackFender_2.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* </div> */}
                      </div>
                    </CardBody>
                    {/* <ReportFooter /> */}
                    <ReportFooter_Swiss />
                  </Card>
                </div>
              </div>

              {/* Back Bumber */}
              <div className="row general-report-page-break p-0">
                <div className="col-sm-12 full-height-col p-0">
                  <Card>
                    <div id="main_footer">
                      <ReportHeader_Swiss />
                    </div>
                    <CardBody className="col-zero">
                      <div className="general_damage_report_wrapper">
                        <div className="container main_container">
                          <div className="row main_row">
                            <div className="col-sm-12">
                              <h3 className="general-report-title">
                                {this.lang("Back")}{" "}
                                <span> {this.lang("View")} </span>{" "}
                              </h3>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftFrontFender_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_LeftBackBumper_4.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("LeftBackBumper")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (
                                                  item.Part ===
                                                  "LeftBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftBackBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftBackBumper"
                                                  ) {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Name</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftBackBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftBackBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {
                                                            dentDamage && dentDamage.name
                                                          }
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Width</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.width
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftBackBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftBackBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage.width}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Height</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.length
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftBackBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftBackBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage.length}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Area</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.area
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftBackBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftBackBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage.area}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Repair Cost</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.repairCost
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "LeftBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "LeftBackBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "LeftBackBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftFrontDoor_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_RightBackBumper_4.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("RightBackBumper")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (
                                                  item.Part === "RightBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackBumper"
                                                  ) {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Name</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage && dentDamage.name
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Width</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.width
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.width
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Height</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.length
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.length
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Area</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.area
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.area
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Repair Cost</th>
                                          {/* <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item && Array.isArray(item.DamagePos) && item.DamagePos.find(
                                                      (pos) => pos.repairCost
                                                    );
                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td> */}
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackBumper"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackBumper" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackBumper"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* </div> */}
                      </div>
                    </CardBody>
                    {/* <ReportFooter /> */}
                    <ReportFooter_Swiss />
                  </Card>
                </div>
              </div>

              {/* Right Side Images - 1 */}
              <div className="row general-report-page-break p-0">
                <div className="col-sm-12 full-height-col p-0">
                  <Card>
                    <div id="main_footer">
                      <ReportHeader_Swiss />
                    </div>
                    <CardBody className="col-zero">
                      <div className="general_damage_report_wrapper">
                        <div className="container main_container">
                          <div className="row main_row">
                            <div className="col-sm-12">
                              <h3 className="general-report-title">
                                {this.lang("Right")}{" "}
                                <span> {this.lang("View")} </span>{" "}
                              </h3>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightFrontFender_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_RightFrontFender_1.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("RightFrontFender")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (
                                                  item.Part ===
                                                  "RightFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "RightFrontFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontFender"
                                                  ) {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Name</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "RightFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "RightFrontFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage && dentDamage.name
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Width</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "RightFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "RightFrontFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.width
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Height</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "RightFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "RightFrontFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.length
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Area</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "RightFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "RightFrontFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.area
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Repair Cost</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "RightFrontFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "RightFrontFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightFrontFender_2.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_RightFrontFender_2.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightFrontDoor_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_RightFrontDoor_1.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("RightFrontDoor")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (
                                                  item.Part === "RightFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "RightFrontDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontDoor"
                                                  ) {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Name</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "RightFrontDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage && dentDamage.name
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Width</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "RightFrontDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.width
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Height</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "RightFrontDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.length
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Area</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "RightFrontDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.area
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Repair Cost</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightFrontDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "RightFrontDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightFrontDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* </div> */}
                      </div>
                    </CardBody>
                    {/* <ReportFooter /> */}
                    <ReportFooter_Swiss />
                  </Card>
                </div>
              </div>

              {/* Right Side Images - 2 */}
              <div className="row general-report-page-break p-0">
                <div className="col-sm-12 full-height-col p-0">
                  <Card>
                    <div id="main_footer">
                      <ReportHeader_Swiss />
                    </div>
                    <CardBody className="col-zero">
                      <div className="general_damage_report_wrapper">
                        <div className="container main_container">
                          <div className="row main_row">
                            <div className="col-sm-12">
                              <h3 className="general-report-title">
                                {this.lang("Right")}{" "}
                                <span> {this.lang("View")} </span>{" "}
                              </h3>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightFrontDoor_2.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_RightFrontDoor_2.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightBackDoor_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_RightBackDoor_1.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("RightBackDoor")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (
                                                  item.Part === "RightBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Name</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage && dentDamage.name
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Width</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.width
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Height</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.length
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Area</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.area
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Repair Cost</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightBackDoor_2.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_RightBackDoor_2.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* </div> */}
                      </div>
                    </CardBody>
                    {/* <ReportFooter /> */}
                    <ReportFooter_Swiss />
                  </Card>
                </div>
              </div>

              {/* Right Side Images - 3 */}
              <div className="row general-report-page-break p-0">
                <div className="col-sm-12 full-height-col p-0">
                  <Card>
                    <div id="main_footer">
                      <ReportHeader_Swiss />
                    </div>
                    <CardBody className="col-zero">
                      <div className="general_damage_report_wrapper">
                        <div className="container main_container">
                          <div className="row main_row">
                            <div className="col-sm-12">
                              <h3 className="general-report-title">
                                {this.lang("Right")}{" "}
                                <span> {this.lang("View")} </span>{" "}
                              </h3>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightBackFender_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_RightBackFender_1.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("RightBackFender")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (
                                                  item.Part ===
                                                  "RightBackFender"
                                                ) {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "RightBackFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackFender"
                                                  ) {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Name</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part ===
                                                  "RightBackFender"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part ===
                                                  "RightBackFender" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackFender"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage && dentDamage.name
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Width</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.width
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Height</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.length
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Area</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.area
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Repair Cost</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "RightBackDoor"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "RightBackDoor" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part ===
                                                    "RightBackDoor"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_RightBackFender_2.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_RightBackFender_2.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* </div> */}
                      </div>
                    </CardBody>
                    {/* <ReportFooter /> */}
                    <ReportFooter_Swiss />
                  </Card>
                </div>
              </div>

              {/* Roof Side Images - 1*/}
              <div className="row general-report-page-break p-0">
                <div className="col-sm-12 full-height-col p-0">
                  <Card>
                    <div id="main_footer">
                      <ReportHeader_Swiss />
                    </div>
                    <CardBody className="col-zero">
                      <div className="general_damage_report_wrapper">
                        <div className="container main_container">
                          <div className="row main_row">
                            <div className="col-sm-12">
                              <h3 className="general-report-title">
                                {this.lang("Roof")}
                              </h3>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_Roof_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_Roof_1.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("Roof")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (item.Part === "Roof") {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Roof" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (item.Part === "Roof") {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Name</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (item.Part === "Roof") {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Roof" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (item.Part === "Roof") {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage && dentDamage.name
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Width</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (item.Part === "Roof") {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Roof" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (item.Part === "Roof") {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.width
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Height</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (item.Part === "Roof") {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Roof" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (item.Part === "Roof") {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.length
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Area</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (item.Part === "Roof") {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Roof" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (item.Part === "Roof") {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.area
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Repair Cost</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (item.Part === "Roof") {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Roof" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (item.Part === "Roof") {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_Roof_2.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_Roof_2.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_Roof_3.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_Roof_3.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* </div> */}
                      </div>
                    </CardBody>
                    {/* <ReportFooter /> */}
                    <ReportFooter_Swiss />
                  </Card>
                </div>
              </div>

              {/* Hood Side Images - 1*/}
              <div className="row general-report-page-break p-0">
                <div className="col-sm-12 full-height-col p-0">
                  <Card>
                    <div id="main_footer">
                      <ReportHeader_Swiss />
                    </div>
                    <CardBody className="col-zero">
                      <div className="general_damage_report_wrapper">
                        <div className="container main_container">
                          <div className="row main_row">
                            <div className="col-sm-12">
                              <h3 className="general-report-title">
                                {this.lang("Hood")}
                              </h3>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_Hood_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_Hood_1.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("Hood")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (item.Part === "Hood") {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Hood" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (item.Part === "Hood") {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Name</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (item.Part === "Hood") {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Hood" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (item.Part === "Hood") {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage && dentDamage.name
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Width</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (item.Part === "Hood") {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Hood" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (item.Part === "Hood") {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.width
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Height</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (item.Part === "Hood") {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Hood" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (item.Part === "Hood") {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.length
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Area</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (item.Part === "Hood") {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Hood" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (item.Part === "Hood") {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.area
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Repair Cost</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (item.Part === "Hood") {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Hood" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (item.Part === "Hood") {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_Hood_2.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_Hood_2.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_Hood_3.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_Hood_3.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* </div> */}
                      </div>
                    </CardBody>
                    {/* <ReportFooter /> */}
                    <ReportFooter_Swiss />
                  </Card>
                </div>
              </div>

              {/* Trunk Side Images - 1*/}
              <div className="row general-report-page-break p-0">
                <div className="col-sm-12 full-height-col p-0">
                  <Card>
                    <div id="main_footer">
                      <ReportHeader_Swiss />
                    </div>
                    <CardBody className="col-zero">
                      <div className="general_damage_report_wrapper">
                        <div className="container main_container">
                          <div className="row main_row">
                            <div className="col-sm-12">
                              <h3 className="general-report-title">
                                {this.lang("Trunk")}
                              </h3>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_Trunk_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_Trunk_1.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("Trunk")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (item.Part === "Trunk") {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Trunk" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (item.Part === "Trunk") {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Name</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (item.Part === "Trunk") {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Trunk" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (item.Part === "Trunk") {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage && dentDamage.name
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Width</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (item.Part === "Trunk") {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Trunk" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (item.Part === "Trunk") {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.width
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Height</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (item.Part === "Trunk") {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Trunk" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (item.Part === "Trunk") {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.length
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Area</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (item.Part === "Trunk") {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Trunk" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (item.Part === "Trunk") {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.area
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Repair Cost</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (item.Part === "Trunk") {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "Trunk" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (item.Part === "Trunk") {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="row main_row">
                            <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12">
                              <div className="general-damage-image-row three-image">
                                {/* <img src='https://drivenscan.com/scanImages/002-sa/2024031300004/Report_TrunkCover_1.jpg' alt='Part Image Name' /> */}
                                <img
                                  alt=""
                                  className="partImage"
                                  src={`${
                                    configuration.imagePath
                                  }/scanImages/${partnerId}/${selectedFile}${
                                    toggleDamageImage ? "/damages" : ""
                                  }/Report_TrunkCover_1.jpg`}
                                  zoom="20"
                                  onError={(img_comp) =>
                                    (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                  }
                                />
                              </div>
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">
                              <div className="general-damage-data-row">
                                <div className="damag-table-wrapper">
                                  <div className="table-responsive">
                                    <table className="table table-bordered">
                                      <thead>
                                        <tr>
                                          <th>{this.lang("Part")}</th>
                                          <th colSpan={2}>
                                            {this.lang("TrunkCover")}
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <th>{this.lang("Type")}</th>
                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item, index) => {
                                                if (
                                                  item.Part === "TrunkCover"
                                                ) {
                                                  const scratchDamage =
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );
                                                  return (
                                                    <p key={index}>
                                                      {scratchDamage
                                                        ? scratchDamage.type 
                                                        : ""}
                                                        &nbsp;
                                                        <span>
                                                        {scratchDamage
                                                        ? `(${scratchDamage.probability + "%" })` 
                                                        : ""}
                                                        </span>
                                                    </p>
                                                  );
                                                }
                                                return null;
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "TrunkCover" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item, index) => {
                                                  if (
                                                    item.Part === "TrunkCover"
                                                  ) {
                                                    const dentDamage =
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <p key={index}>
                                                          {dentDamage.type}
                                                          <span>
                                                          {dentDamage.probability + "%" }
                                                          </span>
                                                        </p>
                                                      );
                                                    }
                                                  }
                                                  return null;
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                        <tr>
                                          <th>Name</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "TrunkCover"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage && scratchDamage.name
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "TrunkCover" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part === "TrunkCover"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage && dentDamage.name
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Width</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "TrunkCover"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.width
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "TrunkCover" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part === "TrunkCover"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.width
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Height</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "TrunkCover"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.length
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "TrunkCover" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part === "TrunkCover"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.length
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Area</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "TrunkCover"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.area
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "TrunkCover" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part === "TrunkCover"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.area
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>

                                        <tr>
                                          <th>Repair Cost</th>

                                          <td>
                                            {Array.isArray(jsonData) &&
                                              jsonData.map((item) => {
                                                if (
                                                  item.Part === "TrunkCover"
                                                ) {
                                                  const scratchDamage =
                                                    Array.isArray(item.DamagePos) &&
                                                    item &&
                                                    Array.isArray(item.DamagePos) &&
                                                    item.DamagePos.find(
                                                      (pos) =>
                                                        pos.type === "SCRATCH"
                                                    );

                                                  return scratchDamage
                                                    ? scratchDamage.repairCost
                                                    : "";
                                                }
                                              })}
                                          </td>
                                          {Array.isArray(jsonData) &&
                                            jsonData.some((item) => {
                                              return (
                                                item.Part === "TrunkCover" &&
                                                item &&
                                                Array.isArray(item.DamagePos) &&
                                                item.DamagePos.some(
                                                  (pos) => pos.type === "DENT"
                                                )
                                              );
                                            }) && (
                                              <td>
                                                {jsonData.map((item) => {
                                                  if (
                                                    item.Part === "TrunkCover"
                                                  ) {
                                                    const dentDamage =
                                                      Array.isArray(item.DamagePos) &&
                                                      item &&
                                                      Array.isArray(item.DamagePos) &&
                                                      item.DamagePos.find(
                                                        (pos) =>
                                                          pos.type === "DENT"
                                                      );
                                                    if (dentDamage) {
                                                      return (
                                                        <span>
                                                          {dentDamage
                                                            ? dentDamage.repairCost
                                                            : ""}
                                                        </span>
                                                      );
                                                    }
                                                  }
                                                })}
                                              </td>
                                            )}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                    <ReportFooter_Swiss />
                  </Card>
                </div>
              </div>

              {/* Tyres Side Images - 1*/}
              <div className="row general-report-page-break p-0">
                <div className="col-sm-12 full-height-col p-0">
                  <Card>
                    <div id="main_footer">
                      <ReportHeader_Swiss />
                    </div>
                    <CardBody className="col-zero">
                      <div className="general_damage_report_wrapper">
                        <div className="container main_container">
                          <div className="row main_row">
                            <div className="col-sm-12">
                              <h3 className="general-report-title">
                                {this.lang("Tyres")}
                              </h3>
                            </div>
                          </div>
                          <div className="row main_row">
                            {tyres.map((image, index) => {
                              return (
                                <>
                                  <div
                                    key={index}
                                    className="col-lg-6 col-md-6 col-sm-6 col-xs-12"
                                  >
                                    <div className="general-damage-image-row tyre-four-image">
                                      {/* <img src="https://drivenscan.com/scanImages/002-sa/2024031300004/Report_LeftFrontTyre_1.jpg" alt="Part Image Name" /> */}{" "}
                                      <img
                                        alt=""
                                        className="partImage"
                                        src={image.src}
                                        zoom="20"
                                        onError={(img_comp) =>
                                          (img_comp.target.src = require("../assets/img/brand/default-image.png"))
                                        }
                                      />
                                    </div>
                                    <div className="general-damage-data-row">
                                      <div className="damag-table-wrapper">
                                        <div className="table-responsive">
                                          <table className="table table-bordered">
                                            <thead>
                                              <tr>
                                                <th colspan={1}>
                                                  {this.lang("Part")}
                                                </th>
                                                <th colspan={3}>
                                                  {this.lang(image.partName)}
                                                </th>
                                              </tr>
                                              <tr>
                                                <th>Make</th>
                                                <th>Type</th>
                                                <th>Dimension</th>
                                                <th>DotCode</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td>
                                                  {Array.isArray(jsonData) &&
                                                    jsonData.map((item) => {
                                                      if (
                                                        item.Part ===
                                                        image.partName
                                                      ) {
                                                        return item.Make
                                                          ? item.Make
                                                          : "-";
                                                      }
                                                    })}
                                                </td>
                                                <td>
                                                  {Array.isArray(jsonData) &&
                                                    jsonData.map((item) => {
                                                      if (
                                                        item.Part ===
                                                        image.partName
                                                      ) {
                                                        return item.TyreType
                                                          ? item.TyreType
                                                          : "-";
                                                      }
                                                    })}
                                                </td>
                                                <td>
                                                  {Array.isArray(jsonData) &&
                                                    jsonData.map((item) => {
                                                      if (
                                                        item.Part ===
                                                        image.partName
                                                      ) {
                                                        return item.TyreDimension
                                                          ? item.TyreDimension
                                                          : "-";
                                                      }
                                                    })}
                                                </td>
                                                <td>
                                                  {Array.isArray(jsonData) &&
                                                    jsonData.map((item) => {
                                                      if (
                                                        item.Part ===
                                                        image.partName
                                                      ) {
                                                        return item.DotCode
                                                          ? item.DotCode
                                                          : "-";
                                                      }
                                                    })}
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </CardBody>
                    <ReportFooter_Swiss />
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ScrollToTop />
      </>
    );
  }
}
const mapStateToProps = (props) => {
  return {
    lang: props.lang,
    toggleReportDamageImage: props.toggleReportDamageImage,
  };
};
const mapDispatchToProps = (dispatch) => ({
  toggleDamageImages: (show) => dispatch(toggleDamageImages(show)),
  reportAuthorized: (show) => dispatch(reportAuthorized(show)),
  updateJsonData: (data) => dispatch(updateJsonData(data)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ReportFullGeneralDamageImage)
);
